import { SnackbarOrigin } from '@mui/material/Snackbar'

export enum ActionType {
  SET_LANG = 'SET_LANG',

  CHANGE_LANG = 'CHANGE_LANG',

  SET_NOTIFICATION = 'SET_NOTIFICATION',

  POST_IMAGE = 'POST_IMAGE',
}

export type TNotificationStatus = 'error' | 'success'

export interface INotification {
  size?: 'sm' | 'md'
  anchorOrigin?: SnackbarOrigin
  status?: TNotificationStatus
  title?: string
  message: string
  autoHideDuration?: number | null
}

export type IStorageImage = {
  fileName?: string
  name?: string
  url?: string
  error?: string
}

export type IStorageImageCallback = (d: IStorageImage) => void

export type IStorageImageArrCallback = (d: IStorageImage[]) => void
